'use client';

import { c as _c } from "react/compiler-runtime";
import { WelloChat } from '@wello-client/chat-sdk/react';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { BREAKPOINTS, ENV } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { DEFAULT_CS_CHAT_LAYOUT, useCsChatLayoutStore } from './CsChatLayout';
import { isCsChatPath } from './csChatPath';

//* 로더가 모바일로 보고 런처 bottom에 safe area를 더하는 폭
const WIDGET_MOBILE_QUERY = '(max-width: 480px)';
const CsChatWidget = t0 => {
  const $ = _c(12);
  const {
    memberToken
  } = t0;
  const probeRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      chrome: 0,
      safeArea: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [inset, setInset] = useState(t1);
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const isWidgetMobile = useMediaQuery(WIDGET_MOBILE_QUERY);
  const isKakaobank = useCheckKakaobank();
  const layout = useCsChatLayoutStore(_temp) ?? DEFAULT_CS_CHAT_LAYOUT;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const probe = probeRef.current;
      if (!probe) {
        return;
      }
      const measure = () => {
        const style = window.getComputedStyle(probe);
        setInset({
          chrome: parseFloat(style.height) || 0,
          safeArea: parseFloat(style.paddingTop) || 0
        });
      };
      measure();
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(probe, {
        box: "border-box"
      });
      return () => {
        resizeObserver.disconnect();
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const spot = isDesktop ? layout.desktop : layout.mobile;
  const chromeInset = isWidgetMobile ? Math.max(inset.chrome - inset.safeArea, 0) : inset.chrome;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div ref={probeRef} aria-hidden={true} className="pointer-events-none invisible fixed bottom-0 left-0 w-0" style={{
      height: "var(--bottom-inset, 0px)",
      paddingTop: "env(safe-area-inset-bottom, 0px)"
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = spot.bottom + chromeInset;
  let t6;
  if ($[4] !== spot.launcherSize || $[5] !== spot.right || $[6] !== t5) {
    t6 = {
      right: spot.right,
      bottom: t5,
      launcherSize: spot.launcherSize
    };
    $[4] = spot.launcherSize;
    $[5] = spot.right;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isKakaobank || $[9] !== memberToken || $[10] !== t6) {
    t7 = <>{t4}<WelloChat memberToken={memberToken} hideLauncher={isKakaobank} src={ENV.NEXT_PUBLIC_CHAT_LOADER_URL} layout={t6} /></>;
    $[8] = isKakaobank;
    $[9] = memberToken;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export const CsChat = () => {
  const $ = _c(2);
  const pathname = usePathname();
  const isLogin = useAuthStore(_temp2);
  const {
    accessToken
  } = useAccessToken();
  const isWebviewAllowed = useDeviceInfoStore(_temp3);
  const isAuthSettled = isLogin === false || isLogin === true && !!accessToken;
  if (!isCsChatPath(pathname) || !isAuthSettled || !isWebviewAllowed) {
    return null;
  }
  const t0 = isLogin ? accessToken : null;
  let t1;
  if ($[0] !== t0) {
    t1 = <CsChatWidget memberToken={t0} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(state) {
  return state.layout;
}
function _temp2(state) {
  return state.isLogin;
}
function _temp3(state_0) {
  return state_0.isMounted && state_0.webviewType !== WEBVIEW_TYPE.KB_PAY;
}